export default {
    url: '/list',
    template: '<user-competence-skill-list/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/competence/skill/list/index.js